var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8241,
    cy: 12.3593,
    r: 11.996,
    fill: "#414651"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5381 13.2107L10.2885 14.2854C10.0679 14.4746 9.89087 14.7093 9.76959 14.9735C9.64831 15.2376 9.58566 15.5248 9.58594 15.8155V17.7593H16.0617V15.8155C16.062 15.5248 15.9993 15.2376 15.878 14.9735C15.7568 14.7093 15.5797 14.4746 15.3591 14.2854L14.1095 13.2107C14.0116 13.1257 13.933 13.0208 13.8789 12.903C13.8247 12.7852 13.7964 12.6572 13.7957 12.5276V12.2083C13.7964 12.0786 13.8247 11.9506 13.8789 11.8328C13.933 11.715 14.0116 11.6101 14.1095 11.5251L15.3591 10.4505C15.5797 10.2613 15.7568 10.0265 15.878 9.7624C15.9993 9.49828 16.062 9.21103 16.0617 8.9204V6.97656H9.58594V8.9204C9.58566 9.21103 9.64831 9.49828 9.76959 9.7624C9.89087 10.0265 10.0679 10.2613 10.2885 10.4505L11.5381 11.5251C11.636 11.6101 11.7146 11.715 11.7688 11.8328C11.8229 11.9506 11.8512 12.0786 11.8519 12.2083V12.5276C11.8512 12.6572 11.8229 12.7852 11.7688 12.903C11.7146 13.0208 11.636 13.1257 11.5381 13.2107Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6951 5.64062H8.95312V6.69863H16.6951V5.64062Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6951 18.0352H8.95312V19.0932H16.6951V18.0352Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockSolid);
export default __webpack_public_path__ + "static/media/clock_solid.37ffe17b3dd6827d27e886878c60234b.svg";
export { ForwardRef as ReactComponent };